import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
    ElementRef,
    ViewChild,
    DestroyRef, inject
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BehaviorSubject} from "rxjs";
import {MenuFormFacadeService} from "@emm/menu/services/menu-form-facade.service";

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-attributes-footer',
    styleUrls: ['./attributes-footer.component.scss'],
    templateUrl: './attributes-footer.component.html'
})
export class AttributesFooterComponent {

    @Input() disableCancel: boolean;
    @Input() disableCascade: boolean;
    @Input() disableUpdate: boolean;
    @Input() locationSet: string;
    @Input() dialogService;
    isChecked = false;

    @Output() cancel = new EventEmitter<void>();
    @Output() update = new EventEmitter<void>();
    @Output() updateItemCascade = new EventEmitter<void>();
    @Output() forceOverrideInheritance = new EventEmitter<boolean>();

    @ViewChild('checkbox') checkbox: ElementRef;

    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    newUpdateFlow$ = this.formFacade.newUpdateFlow$;
    useNewFlow = new BehaviorSubject<boolean>(false);


    constructor(
        private formFacade: MenuFormFacadeService,
    ) {
    }

    handleCancel(): void {
        this.cancel.next();
    }

    handleUpdate(): void {
        this.update.next();
    }

    handleUpdateItemCascade(): void {
        this.updateItemCascade.next();
    }

    handleForceOverrideInheritance($event): boolean {
        this.checkbox['checked'] = this.isChecked;

        this.dialogService.openConfirmDialog('Are you sure you want to force this change?',
            'All lower overrides data will be lost', null)
            .afterClosed()
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(
                res => {
                    this.isChecked = res;
                    this.forceOverrideInheritance.next(res);
                }
            );

        return this.checkbox['checked'];
    }
}
